import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import "../../Styles/ViewReports.css";
import { Close } from '@mui/icons-material';
import { Link } from 'react-router-dom';

function ViewReports() {
  const [reports, setReports] = useState([]);
  const [editReport, setEditReport] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [loading, setLoading] = useState(true);
  const [isUpdateDisabled, setIsUpdateDisabled] = useState(true);
  const [isUpdating, setIsUpdating] = useState(false);

  const fetchReports = async () => {
    const token = localStorage.getItem("authToken");
    try {
      const response = await axios.get("https://api.uniums.com/api/tickets/all-ticket-history", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setReports(response.data.reports || []);
    } catch (error) {
      console.error("Error fetching reports:", error);
      toast.error("Failed to fetch reports");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchReports();
  }, []);

  const handleEditClick = (report) => {
    setEditReport(report);
    setIsEditing(true);
    setIsUpdateDisabled(true); 
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setEditReport((prevReport) => {
      const updatedReport = { ...prevReport, [name]: value };
      if (updatedReport.remark && updatedReport.status) {
        setIsUpdateDisabled(false);
      } else {
        setIsUpdateDisabled(true);
      }

      return updatedReport;
    });
  };

  const handleUpdateReport = async () => {
    if (!editReport.remark || !editReport.status) {
      toast.error("Please fill in the Remark and select a Status before updating.");
      return;
    }
    setIsUpdating(true);
    const token = localStorage.getItem("authToken");
    try {
      await axios.put(
        `https://api.uniums.com/api/tickets/reports/${editReport._id}`,
        { remark: editReport.remark, status: editReport.status },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      toast.success("Report updated successfully");
      setIsEditing(false);
      fetchReports();
    } catch (error) {
      console.error("Error updating report:", error);
      toast.error("Failed to update report");
    } finally {
      setIsUpdating(false);
    }
  };

  if (loading) return <div className="view-report-loading">Loading...</div>;

  return (
    <div className="view-report-container">
      <h1 className="view-report-title">Ticket History</h1>
      <Link to={'/view-report'} >
       <p className='link_text'>Back to Report</p>
      </Link>
      <div className="view-report-list">
        {reports.map((report) => (
          <div className="view-report-card" key={report._id}>
            <div className="view-report-header">
              <h3 className="view-report-subject">{report.subject}</h3>
              <button onClick={() => handleEditClick(report)} className="view-report-edit-btn">Edit</button>
            </div>
            <p><strong>Description:</strong> {report.description}</p>
            <p><strong>Mobile:</strong> {report.mobile}</p>
            <p><strong>Status:</strong> {report.status}</p>
            <p><strong>Created At:</strong> {new Date(report.createdAt).toLocaleString()}</p>
          </div>
        ))}
      </div>

      {isEditing && (
        <div className='view-report-edit-form-container'>
          <div className="view-report-edit-form">
            <h2 className="view-report-edit-title">Edit Report</h2>
            <Close className="view-report-close-icon" onClick={() => setIsEditing(false)} />

            <div className="view-report-form-group">
              <label>Subject</label>
              <input
                type="text"
                name="subject"
                value={editReport.subject}
                disabled
              />
            </div>

            <div className="view-report-form-group">
              <label>Description</label>
              <textarea
                name="description"
                value={editReport.description}
                disabled
              />
            </div>

            <div className="view-report-form-group">
              <label>Remark</label>
              <input
                type="text"
                name="remark"
                value={editReport.remark}
                onChange={handleInputChange}
              />
            </div>

            <div className="view-report-form-group">
              <label>Status</label>
              <select
                name="status"
                value={editReport.status}
                onChange={handleInputChange}
              >
                <option value="">Select Status</option>
                <option value="open">Open</option>
                <option value="closed">Closed</option>
                <option value="resolved">Resolved</option>
                <option value="in-progress">In Progress</option>
              </select>
            </div>

            <button
              onClick={handleUpdateReport}
              className="view-report-update-btn"
              disabled={isUpdateDisabled || isUpdating}
            >
              {isUpdating ? <span className="spinner"></span> : "Update Report"}
            </button>

          </div>
        </div>
      )}
    </div>
  );
}

export default ViewReports;
